import type { IconDef } from '../types';

export const homeOutlined: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M21.36 8.755L15.36 3.305C13.44 1.565 10.55 1.565 8.63 3.305L2.64 8.755C1.6 9.705 1 11.045 1 12.455V18.595C1 20.805 2.79 22.595 5 22.595H19C21.21 22.595 23 20.805 23 18.595V12.455C23 11.045 22.4 9.705 21.36 8.755ZM20.7 18.975C20.65 20.075 19.72 20.935 18.61 20.885L14.99 20.725V14.925C14.99 13.825 14.09 12.925 12.99 12.925H10.99C9.89 12.925 8.99 13.825 8.99 14.925V20.465L4.62 20.275C3.52 20.225 2.66 19.295 2.71 18.185L2.98 12.055C3.02 11.215 3.41 10.415 4.06 9.875L10.3 4.695C10.9 4.195 11.63 3.965 12.35 3.995C13.07 4.025 13.78 4.315 14.33 4.865L20.09 10.575C20.69 11.165 21.01 11.995 20.97 12.835L20.7 18.965V18.975Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
